import { View } from "@-/com.npmjs.react-native";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";

import type { LearnDeckSavedActionUndo } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";

import { RedoReviewButton } from "#redo-review-button";
import { LearnToolbarMapButton } from "#learn-toolbar-map-button";
import { UndoReviewButton } from "#undo-review-button";

/**
 * The deck's cluster above the portrait card or below More at the landscape card's left:
 * Undo, the map button and Redo, in a row (portrait) or a column (landscape). While the Welcome
 * Back card holds the map button beside its Start, the map button's slot is only the gap between
 * Undo and Redo. The study environment is chosen in the More menu.
 * The revealed card's Mnemonics/Info switch lives exclusively in its binder tabs.
 *
 * Rendered outside the deck's tree with history and interaction availability only. Speculative
 * surface readiness must not invalidate the toolbar.
 */
export function LearnDeckHeaderControls({
  isTransitioning,
  savedActionUndo,
}: {
  isTransitioning: boolean;
  savedActionUndo: LearnDeckSavedActionUndo | null;
}) {
  const { diameter, isLandscape } = useToolbarGridMetrics();
  return (
    <View
      // No gap: the map button's slot is the gap between Undo and Redo, and grows with the button.
      className={isLandscape ? "items-center" : "flex-row items-center justify-center"}
      pointerEvents="box-none"
      style={isLandscape ? { width: diameter } : { height: diameter }}
      testID="learn-deck-header-controls"
    >
      <UndoReviewButton isTransitioning={isTransitioning} savedActionUndo={savedActionUndo} />
      <LearnToolbarMapButton />
      <RedoReviewButton isTransitioning={isTransitioning} />
    </View>
  );
}
